// Imports
import React from 'react';
import styled, { ThemeProvider } from 'styled-components/macro';
import { transparentize, darken } from 'polished';
import theme from '../../../../../shareables/theme';


// Export bottom margin
export const fieldContainerBottomMargin = '1.25em';


// The container that holds an entire field (label, control group, error, etc.)
const StyledFieldContainer = styled.div`
	&:not(:last-child) {
		margin-bottom: ${fieldContainerBottomMargin};
	}
	
	.iti {
		width: 100%;
		
		.iti__selected-flag {
			borderRadius: '0.2em',
			borderStyle: '1px solid #000',
			border-color: transparent;
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
			
			&:focus {
				border-color: ${(props) => (props.theme.hasError ? theme.colors.danger : theme.colors.primary)};
				outline: none;
				box-shadow: 0 0 0 0.125em
					${(props) => transparentize(0.75, props.theme.hasError ? theme.colors.danger : theme.colors.primary)};
			}
		}
		
		ul.iti__country-list {
			margin: 0.5em 0 0 -1px;
			border: 1px solid #ccc;
			border-radius: ${(props) => props.theme.borderRadius};
			box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.2);
			z-index: 3;
			
			li.iti__divider {
				margin-top: 0;
				height: 0;
			}
		}
	}
	
	div.ck-editor {
		width: 100%;
		transition: all 0.1s ease;
		border: ${(props) => props.theme.borderStyle};
		border-color: ${(props) => (props.theme.hasError ? theme.colors.danger : '#ddd')};
		border-radius: ${(props) => props.theme.borderRadius};
		
		&:hover:not(:disabled) {
			border-color: ${(props) => darken(0.1, props.theme.hasError ? theme.colors.danger : '#ddd')};
		}
		
		&:focus-within:not(:disabled) {
			border-color: ${(props) => (props.theme.hasError ? theme.colors.danger : theme.colors.primary)};
			outline: none;
			box-shadow: 0 0 0 0.125em
				${(props) => transparentize(0.75, props.theme.hasError ? theme.colors.danger : theme.colors.primary)};
		}
		
		.ck-toolbar, .ck-sticky-panel__content {
			border: none !important;
		}
		
		.ck-content {
			max-height: 100rem;
			border-top-color: var(--ck-color-base-border) !important;
			border-right: none !important;
			border-bottom: none !important;
			border-left: none !important;
			box-shadow: none !important;
			font-family: inherit !important;
			
			.table {
				width: 100%;
				max-width: 100%;
				
				table {
					max-width: 100%;
					margin-bottom: 0;
					background: #fff;
					
					&[style*="border-style:none"] {
						border: dotted 1px #ddd !important;
					}
					
					td, th {
						&[style*="border-style:none"] {
							border: dotted 1px #ddd !important;
						}
					}
				}
			}
			
			img {
				max-width: 100%;
			}
			
			blockquote:not(:last-child),
			dl:not(:last-child),
			ol:not(:last-child),
			p:not(:last-child),
			pre:not(:last-child),
			table:not(:last-child),
			ul:not(:last-child) {
				margin-bottom: 1em;
			}
			
			code {
				background: #eee;
				padding: 0.1em 0.3em;
				border-radius: 0.3em;
				border: 0.1em solid #ddd;
			}
			
			pre {
				max-width: 100%;
				overflow-x: auto;
				
				> code {
					width: fit-content;
					display: block;
				}
			}
			
			blockquote {
				padding: 0.5em 1em;
				background: rgba(0, 0, 0, 0.05);
				border-left: solid 0.3125rem rgba(0, 0, 0, 0.1);
				font-style: inherit;
			}
			
			blockquote > p:first-child {
				margin-top: 0.25rem;
			}
			
			blockquote > p:last-child {
				margin-bottom: 0.25rem;
			}
		}
	}
	
	input[type="checkbox"], input[type="radio"] {
		margin: 0 0.5rem 0 0;
	}
	
	> legend {
		margin-bottom: 0.25em;
		padding-bottom: 0;
	}
`;


// Create theme
const fieldTheme = {
	borderRadius: '0.2em',
	borderStyle: '1px solid #000',
};


// Functional component
const FieldContainer: React.FC<any> = (props) => (
	<ThemeProvider theme={fieldTheme}>
		<StyledFieldContainer data-field-container {...props} />
	</ThemeProvider>
);

export default FieldContainer;
